class studio {
  constructor() {
    if(this.inited) {
      console.log('called studio constructor, but its inited already');
    } else {
      this.inited = true;
      $('.menu a').unbind('click').click(function(e){
        e.preventDefault();
        var href = $(this).attr('href');
        $('.header').removeClass('huge');
        setTimeout(function(){
          window.location.href = href;
        }, 300);
      });

      if(!MOBILE) {
        var first = $('.studio--wrap > .content-block').first();
        let firstH = $(first).outerHeight();
        var val = window.innerHeight*.5 - (firstH/2);
        val = Math.max(val, 150);
        $('.studio--wrap').css('padding-top',val + remToPx(1) );

        var fontsize = parseInt($('.type-heading').first().css('font-size'));
        var valDown = val;
        valDown -= fontsize + remToPx(1);
        $('.type-heading').css({'margin-bottom':valDown});

        $(window).on('resize', function(){
          var first = $('.studio--wrap > .content-block').first();
          let firstH = $(first).outerHeight();
          var val = window.innerHeight*.5 - (firstH/2);
          val = Math.max(val, 150);
          $('.studio--wrap').css('padding-top',val + remToPx(1) );


          var fontsize = parseInt($('.type-heading').first().css('font-size'));
          var valDown = val;
          valDown -= fontsize + remToPx(1);
          $('.type-heading').css({'margin-bottom':valDown});
        });
      // IF MOBILE
      } else {
        // combine slideshows on mobile
        // $('.type-single').each(function(idx){
        //   var tar = $('.type-single').first().find('.single');
        //   if(idx!==0){
        //     $(this).find('.single li').removeClass('act').appendTo(tar);
        //   }
        // });

        $('.studio--wrap > .text-cols > *:nth-child(3) p br').replaceWith(', ');

        $('.studio--wrap .text-cols--col:last-child p a').each(function(){
          var t = $(this).text();
          console.log(t);
          var words = t.split(' ');
          var html = '';
          for(var i=0;i<words.length;i++){
            html += '<span class="aw">'+words[i]+'</span> ';
          }
          $(this).html(html);
        });

        $(window).on('load', function(){
          $('.text-cols em').each(function(){
            let x = $(this).position().left - $(this).parent().position().left;
            if(x==0){
              $(this).prevAll().not('br').first().css('padding-right','5px');
              $(this).css('margin-left','0');
            }
          });
        });
      }

      $('html').addClass('ready');
      if(!window.studiotime){
        window.studiotime = setInterval(function(){
          let d = new Date(new Date().toLocaleString("en-US", {timeZone: "Europe/Stockholm"}));
          let h = parseInt(d.getHours()) < 10 ? '0'+d.getHours() : d.getHours();
          let min = parseInt(d.getMinutes()) < 10 ? '0'+d.getMinutes() : d.getMinutes();
          let sec = parseInt(d.getSeconds()) < 10 ? '0'+d.getSeconds() : d.getSeconds();
          var time = h + ":" + min + ":" + sec;
          $('.tid').text(time+' (CET)');
        }, 950);
      }

      this.initNewsletter();
    }
  }

  initNewsletter(){
    var newsLetterHtml = `
    <div id="mc_embed_signup_studiopage" style="display: none">
    <form action="https://notedesignstudio.us6.list-manage.com/subscribe/post?u=ec6641c2f2ff09f201b754fb7&amp;id=427d34c2a0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
    <div id="mc_embed_signup_scroll">
    <div class="mc-field-group">
    <input type="email" value="" name="EMAIL2" class="newsletter-sub required email" id="mce-EMAIL2" placeholder="email address">
    </div>
    <div id="mce-responses" class="clear">
    <div class="response" id="mce-error-response" style="display:none"></div>
    <div class="response" id="mce-success-response" style="display:none"></div>
    </div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
    <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_ec6641c2f2ff09f201b754fb7_427d34c2a0" tabindex="-1" value=""></div>
    <input style='display:none' type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button">
    </div>
    </form>
    </div>
    <script type='text/javascript'>
    (function($) {
      window.fnames = new Array();
      window.ftypes = new Array();
      fnames[0]='EMAIL2';
      ftypes[0]='email';
    }(jQuery));
    var $mcj = jQuery.noConflict(true);
    </script>

    `;
    $(newsLetterHtml).insertAfter('a[href="#NEWSLETTER"]');

    $('a[href="#NEWSLETTER"]').click(function(e){
      e.preventDefault();
      $('#mc_embed_signup_studiopage').show();
      $(this).hide();
      $('#mc_embed_signup_studiopage .newsletter-sub').focus();
      if($('#mc_embed_signup_studiopage .newsletter-sub').val()==''){
        $('#mc_embed_signup_studiopage .mce_inline_error').text('');
      }
    });

    $('#mc_embed_signup_studiopage .newsletter-sub').on('blur', function(){
      if($(this).val()=='') {
        $('#mc_embed_signup_studiopage').hide();
        $('a[href="#NEWSLETTER"]').show();
      }
    });


    $('.mc-field-group > .required').on('focus', function() {
      var thisField = $(this);

      // backup all mc-form ids on this page
      $('.mc-field-group [id]').each(function() {
        var currentID = $(this).attr('id');
        if ( currentID.indexOf('-bak') == -1 ) {
          $(this).attr('id', currentID + '-bak');
        }
      });
      // change the current form ids back to original state
      var thisForm = thisField.closest('.mc-field-group');
      thisForm.find('[id]').each(function() {
        var currentID = $(this).attr('id');
        if ( currentID.indexOf('-bak') != -1 ) {
          $(this).attr('id', currentID.replace('-bak', ''));
        }
      });
    });

    $.getScript('//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js');
  }
} export default studio;
